import {
  Button,
  IconProps,
  Modal,
  ModalProps,
  ModalRef,
} from '@faxi/web-component-library';
import i18next from 'i18next';
import {
  forwardRef,
  ForwardRefRenderFunction,
  ReactElement,
  ReactNode,
  useImperativeHandle,
  useRef,
} from 'react';

import Icon, { INameExtended } from '../../Icon';
import { StyledInfoModal } from './InfoModal.styled';

export type InfoModalProps = {
  iconName?: INameExtended;
  trigger?: ReactElement;
  closeButtonText?: string;
  children?: ReactNode;
  iconProps?: Omit<IconProps, 'name'>;
} & ModalProps;

export type InfoModalRef = {
  open: () => void;
  close: () => void;
};

const InfoModal: ForwardRefRenderFunction<InfoModalRef, InfoModalProps> = (
  {
    iconName,
    trigger,
    children,
    closeButtonText = i18next.t('ced-action-close'),
    iconProps,
    ...rest
  },
  ref
) => {
  const modalRef = useRef<ModalRef>(null);

  const open = () => modalRef.current?.open();

  const close = () => modalRef.current?.close();

  useImperativeHandle(ref, () => ({ open, close }), []);

  return (
    <StyledInfoModal className="cedolauto-info-modal">
      {trigger ??
        (iconName && (
          <Button
            variant="ghost"
            onClick={() => modalRef.current?.open()}
            icon={<Icon name={iconName} {...iconProps} />}
          />
        ))}

      <Modal
        position="center"
        onClose={() => modalRef.current?.close()}
        ref={modalRef}
        conditionallyControlled={false}
        {...rest}
      >
        <section className="wcl-modal__content">{children}</section>

        <footer className="wcl-modal__actions">
          <Button onClick={() => modalRef.current?.close()} variant="primary">
            {closeButtonText}
          </Button>
        </footer>
      </Modal>
    </StyledInfoModal>
  );
};

export default forwardRef(InfoModal);
